// extracted by mini-css-extract-plugin
export default {"item":"index_item_ZcF9A","itemLink":"index_itemLink_exS3b","itemPic":"index_itemPic_CIDYW","itemAction":"index_itemAction_kndFU"};